var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-fields-edit",
    {
      attrs: {
        title: _vm.$ct("edit-free-block-i", { number: _vm.index + 1 }),
        line: _vm.value.Lines,
      },
      scopedSlots: _vm._u([
        {
          key: "field-options",
          fn: function (slotProps) {
            return [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "4" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          value: !slotProps.field.HideOnDownload,
                          label: _vm.$ct("show-on-download"),
                        },
                        on: {
                          input: function ($event) {
                            slotProps.field.HideOnDownload = !$event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "4" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          value: !slotProps.field.HideOnEmailSend,
                          label: _vm.$ct("show-on-email-send"),
                        },
                        on: {
                          input: function ($event) {
                            slotProps.field.HideOnEmailSend = !$event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "4" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          value: !slotProps.field.HideOnPrint,
                          label: _vm.$ct("show-on-print"),
                        },
                        on: {
                          input: function ($event) {
                            slotProps.field.HideOnPrint = !$event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "template",
        { slot: "title-slot" },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("components.layout-editor.edit-conditions"),
                  expression: "$ct('components.layout-editor.edit-conditions')",
                },
              ],
              attrs: { sm: "", flat: "" },
              on: {
                click: function ($event) {
                  _vm.editConditionsOpen = true
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "filter" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-input", {
                attrs: {
                  value: _vm.name,
                  label: _vm.$ct("common.name"),
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.onNameInput($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("app-select-placement", {
                attrs: {
                  layout: _vm.layout,
                  "full-control": true,
                  value: _vm.value.Placement,
                  fancy: "",
                  label: _vm.$ct("placement"),
                },
                on: {
                  input: function ($event) {
                    return _vm.setPlacement($event)
                  },
                },
              }),
            ],
            1
          ),
          _vm.editConditionsOpen
            ? _c("app-conditions-edit-modal", {
                attrs: { fields: _vm.conditionProps },
                on: {
                  close: function ($event) {
                    _vm.editConditionsOpen = false
                  },
                },
                model: {
                  value: _vm.value.Conditions,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Conditions", $$v)
                  },
                  expression: "value.Conditions",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }